export default __webpack_public_path__ + "static/media/footer-logo.212c0681.svg";